<template>
  <ul class="single-comment__header">
    <li class="single-comment__item single-comment__logo">
      <img :src="comment.author_logo" class="single-comment__img" referrerpolicy="no-referrer">
    </li>
    <li class="single-comment__item single-comment__author">
      <span class="single-comment__author-name">{{comment.author}}</span>
      <span class="single-comment__author-date">{{comment.created_date}}</span>
    </li>
    <li class="single-comment__item single-comment__likes">
      <img src="../../../../../../../assets/img/favorite.svg" class="single-comment__likes-img">
      <span class="single-comment__likes-count">{{comment.likes}}</span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'CommentHeader',
    props: {
      comment: {
        type: Object
      }
    }
  };
</script>

<style>
  .single-comment__header {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }
  .single-comment__logo {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
  }
  .single-comment__img {
    width: 40px;
  }
  .single-comment__item {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .single-comment__author {
    display: flex;
    flex-direction: column;
  }
  .single-comment__author-name {
    color: #1F2F3D;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 5px;
  }
  .single-comment__author-date {
    color: #5E6D82;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
  }
  .single-comment__likes {
    display: flex;
    align-items: flex-start;
    margin-left: auto;
  }
  .single-comment__likes-img {
    margin-right: 5px;
  }
  .single-comment__likes-count {
    color: #5E6D82;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    margin-top: -2px;
  }
</style>
